export default class OKXPublicClient {
    constructor(baseURL = "https://www.okx.com") {
        this.baseURL = baseURL
    }

    _request(path, params = {}) {
        const qs = new URLSearchParams(params).toString()
        const url = this.baseURL + path + (qs ? "?" + qs : "")

        return fetch(url)
            .then(async (response) => {
                const data = await response.json()

                // 检查 HTTP 状态码
                if (!response.ok) {
                    const error = new Error(`HTTP ${response.status}: ${response.statusText}`)
                    error.statusCode = response.status
                    error.data = data
                    throw error
                }

                // 检查 OKX 业务错误码
                if (data.code !== "0") {
                    const error = new Error(data.msg || `OKX API Error ${data.code}`)
                    error.code = data.code
                    error.msg = data.msg
                    throw error
                }

                return data.data
            })
    }

    // 获取市场交易对信息
    getInstruments(instType = "SWAP") {
        return this._request("/api/v5/public/instruments", { instType })
    }

    // 获取标记价格
    getMarkPrice(instType, instId) {
        return this._request("/api/v5/public/mark-price", { instType, instId })
    }

    // 获取资金费率
    getFundingRate(instId) {
        return this._request("/api/v5/public/funding-rate", { instId })
    }
}